import { useTranslator } from "components/Translator"
import { CommentAlt } from "components/Icon"
import { LabelWithIcon } from "components/LabelWithIcon"

export const UserNbForumPosts = ({ user }) => {
  const translator = useTranslator()

  if (user.nbForumPosts === null || user.nbForumPosts === undefined) {
    return null
  }

  return (
    <LabelWithIcon
      icon={<CommentAlt className="w-4 text-primary-default" />}
      label={
        <span className={"line-clamp-1"}>
          {translator.transChoice(
            "UserInfos.nbForumPosts",
            user.nbForumPosts,
            { nbForumPosts: user.nbForumPosts },
            "components",
          )}
        </span>
      }
    />
  )
}
